export var TypeActionPurchasePointsEventInfo;
(function (TypeActionPurchasePointsEventInfo) {
    TypeActionPurchasePointsEventInfo["Received"] = "PurchasePointsEvent > Received";
    TypeActionPurchasePointsEventInfo["HideHudButton"] = "PurchasePointsEvent > HideHudButton";
})(TypeActionPurchasePointsEventInfo || (TypeActionPurchasePointsEventInfo = {}));
export var actionPurchasePointsReceived = function (purchasePoints) { return ({
    purchasePoints: purchasePoints,
    type: TypeActionPurchasePointsEventInfo.Received,
}); };
export var actionPurchasePointsHideHudButton = function () { return ({
    type: TypeActionPurchasePointsEventInfo.HideHudButton,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/purchase-points-event/actionPurchasePointsEventInfo.ts
// module id = 420
// module chunks = 3